import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useStatiegeldStats } from "../../store/useStatiegeldStats";
import { useStatiegeldProducts } from "../../store/useStatiegeldProducts";
import { useMemo } from "react";
import { useNavigate } from "react-router";

dayjs.extend(relativeTime);

export const StatiegeldBarcodeTable = () => {
  /** Hooks */
  const navigate = useNavigate();
  const { statiegeldStats } = useStatiegeldStats();
  const { statiegeldProducts } = useStatiegeldProducts();

  const reorderProductsByCount = useMemo(() => {
    return statiegeldStats?.gtinStats?.sort(
      (a, b) => b.totalItems - a.totalItems
    );
  }, [statiegeldStats?.gtinStats]);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Product name
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              GTIN
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Count
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Refund
            </th>
          </tr>
        </thead>
        <tbody>
          {reorderProductsByCount?.map((item) => {
            const productName = statiegeldProducts?.find(
              // @ts-ignore
              (product) => product?.gtin === item?.barcode
            );
            if (!productName) {
              return null;
            }
            return (
              <tr
                onClick={() =>
                  navigate(
                    `/statiegeld-product-users-list/barcode/${item?.barcode}`
                  )
                }
                key={item.barcode}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap text-xs sm:text-base">
                  {productName?.name ?? "Unknown"}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base">
                  {item?.barcode}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base">
                  {item?.totalItems}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {Number(item?.totalRefund / 1000 ?? 0)?.toFixed(2)} €
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
